'use client'

import { useTicketWebSocket } from '@/hooks/useTicketWebSocket'
import { ReactNode } from 'react'

/**
 * Provider component that enables real-time WebSocket synchronization for tickets
 *
 * All ticket WebSocket logic is centralized in useTicketWebSocket hook.
 * This provider simply calls that hook to enable real-time updates globally.
 *
 * Works transparently in the background - no UI changes required.
 */
export function TicketWebSocketProvider({ children }: { children: ReactNode }) {
  // All ticket WebSocket logic (connection + event handling) is in this single hook
  useTicketWebSocket()

  return <>{children}</>
}
